import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './ThemeContext';
import { AuthProvider } from './AuthContext';
import { SpAccountProvider } from './SpAccountContext';
import { PreferencesProvider } from './PreferencesContext';
import { ToastProvider } from './components/Toast';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <PreferencesProvider>
          <SpAccountProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </SpAccountProvider>
        </PreferencesProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
